import { useSearchParams } from "react-router-dom";
import { ExerciseLoadType } from "../../../models";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
 
import { CreateButton } from "./ui/buttons";
import ExerciseLoadTypeService from "../../../services/ExerciseLoadTypeService";
import ExerciseLoadTypesTableSkeleton from "./skeletons/ExerciseLoadTypesTableSkeleton";
import ExerciseLoadTypesTable from "./ui/ExerciseLoadTypesTable";

export default function ExerciseLoadTypesPage(){
  const [searchParams] = useSearchParams();
  const api = new ExerciseLoadTypeService();
  const [items, setItems] = useState<ExerciseLoadType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [searchParams.get("reload")]);

  const fetchData = async () => {
    const data = await api.getExerciseLoadTypes();
    setItems(data);
    setLoading(false);
  };

  return (
    <div className="w-full">
         <Breadcrumbs
                    breadcrumbs={[
                      { label: "Exercise Load Types", href: "/admin/exercise-load-types" },                      
                    ]}
                  />
      
      <CreateButton />
      {loading ? (
        <ExerciseLoadTypesTableSkeleton />
      ) : (
        <ExerciseLoadTypesTable items={items} />
      )}
    </div>
  );
}
